/* src/app/driver/pages/driver-hours/driver-hours.component.scss */
table .nameCol {
  padding-right: 2rem;
}
table input[type=time] {
  width: 9rem;
}
.searchContainer {
  display: flex;
  flex-flow: row wrap;
}
.btnSearch {
  padding: 0;
  height: 2rem;
  margin-top: 1rem;
  margin-left: 1rem;
  display: inline-block;
}
/*# sourceMappingURL=driver-hours.component.css.map */
